import React from 'react';
import { Button, Tooltip } from '@mui/material';

const QuickActionButton = ({ title, icon, onClick, description, fullWidth = true, size = 'large' }) => (
  <Tooltip title={description} arrow placement="top">
    <Button
      variant="contained"
      size={size}
      onClick={onClick}
      startIcon={icon}
      fullWidth={fullWidth}
      sx={{
        minHeight: 56,
        borderRadius: 2,
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '1rem',
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        color: 'white',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.25)',
          transform: 'translateY(-2px)',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
          border: '1px solid rgba(255, 255, 255, 0.4)',
        },
        '&:active': {
          transform: 'translateY(0)',
        },
      }}
    >
      {title}
    </Button>
  </Tooltip>
);

export default QuickActionButton;
